import RefluencedCreditIcon from "@/assets/colorable/refluenced_credit.svg?react";
import clsxm from "@/lib/clsxm";
import {type FC} from "react";
import {useTranslation} from "react-i18next";
import {NumericFormat} from "react-number-format";

const CreditInputField: FC<{
  onChange?: (value: number | null) => void;
  onClickCredits?: () => void;
  type: "add" | "remove" | "balance";
  typeClassName?: string;
  value?: number | null;
}> = ({onChange, onClickCredits, type, typeClassName, value}) => {
  const {t} = useTranslation("common");

  return (
    <div className="flex w-full flex-col gap-2">
      {type === "balance" && <span className="text-neutral-black text-xs">{t("credits_overview")}</span>}
      <div className="flex items-center gap-2">
        <div
          className={clsxm(
            "bg-neutral-grey-light-dark flex min-h-15 items-center gap-2 rounded-md px-3.5 py-2",
            typeClassName,
          )}>
          {type === "add" && <span className="text-neutral-black text-2.5xl font-semibold">+</span>}
          {type === "remove" && <span className="text-neutral-black text-2.5xl font-semibold">-</span>}
          <RefluencedCreditIcon className="text-neutral-black size-4.5" />
        </div>
        <div className={clsxm("w-full", onClickCredits && "cursor-pointer")} onClick={onClickCredits}>
          <NumericFormat
            allowNegative={false}
            className={clsxm(
              "text-neutral-black border-neutral-grey-light-dark focus:border-primary-medium-solid disabled:bg-neutral-grey-light-dark text-2.5xl flex min-h-15 w-full items-center rounded-md border bg-white px-3 py-2 font-semibold outline-hidden",
              onClickCredits && "pointer-events-none",
            )}
            decimalScale={2}
            disabled={type === "balance"}
            onValueChange={values => onChange?.(values.floatValue ?? null)}
            thousandSeparator=","
            value={value ?? ""}
          />
        </div>
      </div>
    </div>
  );
};

export default CreditInputField;
